import organizationState from "./state";

export default {
  getItemById:
    (state = organizationState) =>
    (id) => {
      return state.data.find((item) => item.id === id);
    }
};
